/**
 * RequestCard Component (Sponsor View)
 *
 * Simplified card display for a sponsor's own advisory request
 */

import React from 'react';

import { formatDistanceToNow } from 'date-fns';

import StatusBadge from '../../LeadRequestOrchestration/components/StatusBadge';
import * as S from '../../LeadRequestOrchestration/components/styles';
import Button from 'components/Button';
import Text from 'components/Text';
import { LeadRequest, LeadRequestStatus } from 'types/leadRequestsTypes';

interface RequestCardProps {
  request: LeadRequest;
  onViewDetails: (request: LeadRequest) => void;
  onCancel: () => void;
  isCanceling: boolean;
}

const RequestCard: React.FC<RequestCardProps> = ({
  request,
  onViewDetails,
  onCancel,
  isCanceling,
}) => {
  const createdAt = new Date(request.created_at);
  const timeAgo = formatDistanceToNow(createdAt, { addSuffix: true });

  // Preview of form responses
  const getFormPreview = (): string => {
    if (!request.form_responses) return 'Nenhum dado do formulário';
    if (typeof request.form_responses === 'object' && !Array.isArray(request.form_responses)) {
      const entries = Object.entries(request.form_responses).slice(0, 2);
      return entries.map(([key, value]) => `${key}: ${String(value)}`).join(' | ') || 'Nenhum dado';
    }
    return 'Dados do formulário disponíveis';
  };

  return (
    <S.RequestCard onClick={() => onViewDetails(request)}>
      <S.CardHeader>
        <S.CardTitle>
          <Text size="large" bold>
            Solicitação #{request.id.slice(0, 8)}
          </Text>
          <StatusBadge status={request.status} size="small" />
        </S.CardTitle>
      </S.CardHeader>

      <S.CardBody>
        <S.InfoRow>
          <S.InfoLabel>Visualização:</S.InfoLabel>
          <S.InfoValue>{getFormPreview()}</S.InfoValue>
        </S.InfoRow>
      </S.CardBody>

      <S.CardFooter>
        <Text size="small" color="textSecondary">
          Criado {timeAgo}
        </Text>
        <S.CardActions onClick={e => e.stopPropagation()}>
          <Button variant="outline" size="XSmall" onClick={() => onViewDetails(request)}>
            Ver detalhes
          </Button>
          <Button
            variant="red"
            size="XSmall"
            onClick={onCancel}
            // loading={isCanceling}
            disabled={isCanceling || request.status === LeadRequestStatus.CANCELED}
          >
            Cancelar
          </Button>
        </S.CardActions>
      </S.CardFooter>
    </S.RequestCard>
  );
};

export default RequestCard;
